import { useCallback } from "react";

type MessageMap = Record<string, string>;

const useTranslation = (messages: MessageMap) => {
  const t = useCallback(
    (key: string, params?: Record<string, string | number>) => {
      const template = messages[key] || key;

      if (!params) return template;

      return template.replace(/{(\w+)}/g, (_, k) => String(params[k] ?? ""));
    },
    [messages]
  );

  return { t };
};

export default useTranslation;
